export const wordPrintDocument = (editor) => {
  if (!editor) return;

  const html = editor.getHTML();

  const printWindow = window.open("", "_blank", "width=900,height=1000");

  if (!printWindow) {
    alert("Please allow pop-ups in your browser to print the document.");

    return;
  }

  printWindow.document.open();

  printWindow.document.write(`
    <!DOCTYPE html>

    <html>

    <head>

      <meta charset="UTF-8" />

      <title>RailSetu</title>

      <style>

        /* =================================================
           PAGE
        ================================================= */

        @page {
          size: A4;
          margin: 15mm;
        }

        /* =================================================
           RESET
        ================================================= */

        * {
          box-sizing: border-box;
        }

        html {
          background: #ffffff !important;

          color: #000000 !important;

          color-scheme: light !important;
        }

        body {
          margin: 0 !important;

          padding: 0 !important;

          background: #ffffff !important;

          color: #000000 !important;

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          font-size: 16px;

          line-height: 1.6;

          overflow: visible !important;
        }

        /* =================================================
           PRINT PAGE
        ================================================= */

        .print-page {
          position: relative;

          width: 100%;

          min-height: 100vh;

          background: #ffffff;

          color: #000000;

          overflow: visible;
        }

        /* =================================================
           WATERMARK
        ================================================= */

        .watermark {
          position: fixed;

          top: 50%;
          left: 50%;

          transform:
            translate(-50%, -50%)
            rotate(-35deg);

          font-family:
            Arial,
            Helvetica,
            sans-serif;

          font-size: 90px;

          font-weight: 700;

          letter-spacing: 8px;

          color: rgba(0, 70, 140, 0.08);

          white-space: nowrap;

          pointer-events: none;

          user-select: none;

          z-index: 0;

          width: 100%;

          text-align: center;
        }

        /* =================================================
           DOCUMENT CONTENT
        ================================================= */

        .print-document {
          position: relative;

          z-index: 1;

          width: 100%;

          margin: 0;

          padding: 0;

          background: transparent;

          color: #000000;
        }

        /* =================================================
           TEXT
        ================================================= */

        .print-document,
        .print-document p,
        .print-document span,
        .print-document div,
        .print-document h1,
        .print-document h2,
        .print-document h3,
        .print-document h4,
        .print-document h5,
        .print-document h6,
        .print-document li,
        .print-document td,
        .print-document th {
          color: #000000 !important;
        }

        p {
          margin: 8px 0;
        }

        h1 {
          font-size: 32px;

          line-height: 1.2;

          margin-top: 0;

          margin-bottom: 20px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        h2 {
          font-size: 26px;

          line-height: 1.25;

          margin-top: 25px;

          margin-bottom: 15px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        h3 {
          font-size: 22px;

          line-height: 1.3;

          margin-top: 20px;

          margin-bottom: 12px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        h4 {
          font-size: 19px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        h5 {
          font-size: 17px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        h6 {
          font-size: 15px;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        /* =================================================
           LINKS
        ================================================= */

        a {
          color: #000000 !important;

          text-decoration: underline !important;
        }

        /* =================================================
           LISTS
        ================================================= */

        ul,
        ol {
          padding-left: 25px;
        }

        li {
          color: #000000 !important;
        }

        /* =================================================
           IMAGES
        ================================================= */

        img {
          display: block;

          max-width: 100% !important;

          height: auto !important;

          margin: 10px auto;

          break-inside: avoid;

          page-break-inside: avoid;
        }

        /* =================================================
           TABLE
        ================================================= */

        table {
          width: 100% !important;

          max-width: 100% !important;

          border-collapse: collapse !important;

          table-layout: auto !important;

          margin: 20px 0;

          background: #ffffff !important;

          color: #000000 !important;

          page-break-inside: auto;

          break-inside: auto;
        }

        tr {
          page-break-inside: avoid !important;

          break-inside: avoid !important;
        }

        th,
        td {
          border: 1px solid #000000 !important;

          padding: 7px 9px !important;

          vertical-align: top;

          background: #ffffff !important;

          color: #000000 !important;

          white-space: normal;

          overflow-wrap: anywhere;

          word-break: break-word;
        }

        th {
          font-weight: bold;

          background: #ffffff !important;
        }

        td p,
        th p {
          margin: 0;
        }

        /* =================================================
           CODE
        ================================================= */

        code {
          color: #000000 !important;

          background: transparent !important;
        }

        pre {
          color: #000000 !important;

          background: #ffffff !important;

          border: 1px solid #000000;

          padding: 10px;

          white-space: pre-wrap;

          overflow: visible;
        }

        /* =================================================
           BLOCKQUOTE
        ================================================= */

        blockquote {
          color: #000000 !important;

          background: #ffffff !important;

          border-left: 3px solid #000000;

          padding-left: 15px;
        }

        /* =================================================
           HR
        ================================================= */

        hr {
          border: 0;

          border-top: 1px solid #000000;
        }

        /* =================================================
           MANUAL PAGE BREAK
        ================================================= */

        .page-break {
          display: block !important;

          width: 100% !important;

          height: 0 !important;

          margin: 0 !important;

          padding: 0 !important;

          border: 0 !important;

          background: transparent !important;

          page-break-after: always !important;

          break-after: page !important;
        }

        /* =================================================
           PRINT
        ================================================= */

        @media print {

          html,
          body {
            background: #ffffff !important;

            color: #000000 !important;
          }

          /*
           * Keep watermark visible when printing.
           */

          .watermark {
            display: block !important;
            Z-index:100;
            print-color-adjust: exact;

            -webkit-print-color-adjust: exact;
          }
        }

      </style>

    </head>

    <body>

      <!-- WATERMARK -->

      <div class="watermark">
        RAILSETU
      </div>

      <!-- DOCUMENT -->

      <div class="print-page">

        <div class="print-document">

          ${html}

        </div>

      </div>

    </body>

    </html>
  `);

  printWindow.document.close();

  /*
   * Give the browser time to render
   * images, tables and content.
   */

  setTimeout(() => {
    printWindow.focus();

    printWindow.print();

    /*
     * Close after print dialog starts.
     */

    setTimeout(() => {
      printWindow.close();
    }, 500);
  }, 500);
};
